import Icon from '../../components/Icon'

Icon.register({
  'brands/wodu': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M178.4 339.7h-37.3l-28.9-116.2h-0.5l-28.5 116.2h-38l-45.2-170.8h37.5l27 116.2h0.5l29.7-116.2h35.2l29.2 117.7h0.5l28-117.7h36.8zM271.4 212.7c39 0 64.1 25.8 64.1 65.3 0 39.2-25.1 65-64.1 65-38.7 0-63.9-25.8-63.9-65 0-39.5 25.1-65.3 63.9-65.3zM271.4 317.5c23.2 0 30.1-19.9 30.1-39.5 0-19.9-6.9-39.7-30.1-39.7-27.7 0-29.9 19.9-29.9 39.7 0 19.6 6.9 39.5 29.9 39.5zM435.1 323.9h-0.5c-7.9 13.4-21.8 19.1-37.5 19.1-37.3 0-55.5-32-55.5-66.2 0-33.2 18.4-64.1 54.8-64.1 14.6 0 28.9 6.2 36.8 18.4h0.2v-62.2h34v170.8h-32.3v-15.8zM405.4 238.3c-22.2 0-29.9 19.1-29.9 39.5 0 19.4 8.8 39.7 29.9 39.7 22.5 0 29.2-19.6 29.2-39.9 0-20.1-7.2-39.2-29.2-39.2zM593 339.7h-32.3v-17.2h-0.7c-8.6 13.9-23.4 20.6-37.8 20.6-36.1 0-45.2-20.3-45.2-50.9v-76.1h34v69.8c0 20.3 6 30.4 21.8 30.4 18.4 0 26.3-10.3 26.3-35.4v-64.8h34v123.6zM602.5 302.9h37.5v36.8h-37.5v-36.8z'
      }
    ]
  }
})
